export default "__VITE_ASSET__BClC3JBT__"